import Vue from "vue";
import "@hotwired/turbo-rails";
import TurbolinksAdapter from "vue-turbolinks";

Vue.use(TurbolinksAdapter);

import "../application/sticky-header";

import { urlHelpers } from "utilities/utilities";

import LocationForm from "../location/components/LocationForm";

document.addEventListener("turbo:load", function () {
  const locationFormElems = document.querySelectorAll(
    ".vue-enable-location-form"
  );

  for (let i = 0; i < locationFormElems.length; i += 1) {
    new Vue({
      el: locationFormElems[i],

      components: {
        LocationForm,
      },

      methods: {
        goBack() {
          const returnTo = urlHelpers.fetchGetParameterValue("return_to");
          if (returnTo) {
            window.location.href = returnTo;
          } else {
            window.history.back();
          }
        },
      },
    });
  }
});
